// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"c8b71458","346":"c8b31a99","854":"c8b71458"}[chunkId] + ".chunk.css";
};